import { localStorageKeys } from '@/shared/config'

export const getAccessToken = (): string | null => localStorage.getItem(localStorageKeys.accessToken)

export const setAccessToken = (token: string): void => {
  localStorage.setItem(localStorageKeys.accessToken, token)
}

export const clearAccessToken = (): void => {
  localStorage.removeItem(localStorageKeys.accessToken)
}
